// material-ui
import { styled } from '@mui/material/styles';

// project imports
import { MenuOrientation } from 'config';
import { drawerWidth, drawerWidthCollapsed, HEADER_HEIGHT } from 'store/constant';

const HORIZONTAL_HEADER_HEIGHT = HEADER_HEIGHT + 65; // Header + horizontal menu bar

interface MainStyleProps {
  open: boolean;
  menuOrientation: MenuOrientation;
  borderRadius: number;
}

// ==============================|| MAIN LAYOUT - STYLED ||============================== //

const MainContentStyled = styled('main', {
  shouldForwardProp: (prop) => prop !== 'open' && prop !== 'menuOrientation' && prop !== 'borderRadius'
})<MainStyleProps>(({ theme, open, menuOrientation }) => ({
  // Transparent background to let page backgrounds show through
  backgroundColor: 'transparent',
  minWidth: '1%',
  flexGrow: 1,
  padding: 0,
  marginTop: HEADER_HEIGHT,
  marginRight: 0,
  borderRadius: 0,
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.easeOut,
    duration: 400
  }),

  // Mobile (< md): Full width, no sidebar
  width: '100%',
  marginLeft: 0,
  minHeight: `calc(100vh - ${HEADER_HEIGHT}px)`,

  // Tablet + Desktop (md and up): Respect drawer open state
  [theme.breakpoints.up('md')]: {
    width: open ? `calc(100% - ${drawerWidth}px)` : `calc(100% - ${drawerWidthCollapsed}px)`,
    marginLeft: 0,
    marginTop: menuOrientation === MenuOrientation.HORIZONTAL ? HORIZONTAL_HEADER_HEIGHT : HEADER_HEIGHT
  }
}));

export default MainContentStyled;
